import { useAuth } from '../useAuth/useAuth'

import { getPartnerFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export const useSelfServeMatchingEnabled = (): boolean => {
  const { state } = useAuth()
  const partner = getPartnerFromAuthState(state)

  return partner?.selfServeMatching === true
}
